var infoForAuthWindowMap = {};
export function setAuthWindowInfo(providerType, authInfo) {
    infoForAuthWindowMap[providerType] = authInfo;
}
export function getAuthWindowInfo(providerType) {
    if (providerType in infoForAuthWindowMap) {
        return infoForAuthWindowMap[providerType];
    }
    return null;
}
export function clearAuthWindowInfo(providerType) {
    infoForAuthWindowMap[providerType] = null;
}
//# sourceMappingURL=AuthWindowInfo.js.map